import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { CodeInput } from "../../components/CodeInput/code-input";
import {
  apiRequest,
  showLoading,
  saveTeamUUID,
  savePlayerCode,
  saveSessionUUID,
} from "../../utils";

import ss from "./login.module.css";

export const LoginPage = () => {
  const session_uuid = new URLSearchParams(window.location.search).get("sid");
  const navigate = useNavigate();
  const [confirmBtnDisabled, setConfirmBtnDisabled] = useState(true);
  const codeInputRef = useRef("");
  const [hint, setHint] = useState("");

  const onConfirmClick = () => {
    setHint("");
    const loading = showLoading("加载中");
    apiRequest("/player_login", "POST", {
      sid: session_uuid,
      code: codeInputRef.current,
    })
      .then((res) => {
        if (res.code === 0) {
          saveSessionUUID(session_uuid);
          saveTeamUUID(res.team_uuid);
          savePlayerCode(codeInputRef.current);
          if (res.session_status === 0) {
            navigate("/guide", { replace: true });
          } else navigate("/game", { replace: true });
        } else setHint(res.msg);
      })
      .finally(() => loading.hide());
  };

  const checkCodeInputFinished = () => {
    const code = codeInputRef.current;
    return code.length === 4;
  };

  return (
    <div className={ss.page}>
      <div className={ss.loginBox}>
        <div className={ss.label}>请输入登录码</div>
        <div className={ss.inputWrapper}>
          <CodeInput
            name="code1"
            onChange={(code) => {
              codeInputRef.current = code;
              setConfirmBtnDisabled(!checkCodeInputFinished());
            }}
          />
        </div>
        <div className={ss.hint}>{hint}</div>
      </div>
      <div
        className={classNames(ss.confirmBtn, confirmBtnDisabled && ss.disabled)}
        onClick={onConfirmClick}
      >
        确认
      </div>
    </div>
  );
};
